/**
 ** Global JS events
 */


// Automatically grab Click events and push them to GA.
document.addEventListener('click', function(event) {
  let target = event.target;

  /**
   * We need to be specific of which elements we want to grab.
   * Auto grab all <a> and <button> elements
   * Grab any element with attribute `data-ga-label`
   *
   * @param {attribute} data-ga-label : Required on non <a> or <button> elements
   * @param {attribute} data-ga-cat : Optional - can be on any parent element
   * @param {attribute} data-ga-action : Optional - Override event action
   */

  /**
   * Assing the target in this order
   * 1. Has attribute `data-ga-label`
   * 2. Is a <button> or <a>
   * 3. ParentElement is an <a> or has `data-ga-label` (Needed for bubbling events for :before)
   */
  target = target.hasAttribute('data-ga-label') ? target
    : (target.nodeName == "BUTTON" || target.nodeName == "A") ? target
      : (target.parentNode &&
        (target.parentNode.nodeName == "A" || target.parentNode.hasAttribute('data-ga-label')
      )
    ) ?  target.parentElement : false;

  if(target) {
      // Assign categoryTarget to initialize loop
      let categoryTarget = target;
      // Default category label
      let category = target.hasAttribute('data-ga-cat') ? target.getAttribute('data-ga-cat') : null;

      // Bubble up DOM until we get a proper GA Category name
      if(!category) {
        while( (categoryTarget = categoryTarget.parentNode) && categoryTarget.nodeName !== 'BODY' && !(category = categoryTarget.getAttribute('data-ga-cat')))  {}
      }

      // Define page, action, and label and set default category if none was found (exception case)
      let page = document.location.pathname === '/' ? 'homepage' : document.location.pathname.substr(1).replace(/\//g, '_');
      let action = target.hasAttribute('data-ga-action') ? target.getAttribute('data-ga-action') : 'Click';
      category = category ? category : target.nodeName == 'A' ? "link" : "button";

      // for generic Links, include the href it is going to (e.g. LEARN MORE/installers)
      let label = target.hasAttribute('data-ga-label') ? target.getAttribute('data-ga-label')
        : target.hasAttribute('alt') ? target.getAttribute('alt')
          : target.innerText + (category === 'link' ? target.getAttribute('href') : '');

      // Create event object with page
      let gaEvent = {
          'hitType' : 'event',
          'eventCategory' : `${page}:${category.toLowerCase().replace(/\s/g, '_')}`,
          'eventAction' : action,
          'eventLabel' : label.toLowerCase().replace(/\s/g, '_')
      };

      try {
          ga('send', gaEvent);
      }
      catch(e) {
          console.log(e);
      }
  }
});

/**
 * Custom History Event dispatched from AppContainer.js router update method
 */
class GAScroll {
  constructor() {
    this.domHeight = 0;
    this.domPositions = [];
    this.page = '';

    this.initScrollEvent();
  }

  set = () => {
    this.page = document.location.pathname === '/' ? 'homepage' : document.location.pathname.substr(1).replace(/\//g, '_');
    this.domHeight = document.documentElement.scrollHeight - window.innerHeight;
    this.domPositions = [
      {
        label: "25%",
        height: this.domHeight * .25
      },
      {
        label: "50%",
        height: this.domHeight * .50
      },
      {
        label: "75%",
        height: this.domHeight * .75
      },
      {
        label: "100%",
        height: this.domHeight * .95 // more realistic measurement for 100%
      }];
  }

  initScrollEvent = () => {
    document.addEventListener('scroll', (event) => {
      // Adjust for when scrolling alters page height (e.g. loading images)
      if(this.domHeight !== document.documentElement.scrollHeight - window.innerHeight) {
        this.set();
      }
      if(this.domPositions.length && window.pageYOffset > this.domPositions[0].height) {

        let gaEvent = {
            'hitType' : 'event',
            'eventCategory' : "Scroll Distance",
            'eventAction' : "Scroll",
            'eventLabel' : `${this.page}:scroll:${this.domPositions[0].label}`
        };

        this.domPositions.shift();

        try {
            ga('send', gaEvent);
        }
        catch(e) {
            console.log(e);
        }
      }
    });
  }
}
let gaScroll = new GAScroll();
window.addEventListener('historyChange', function(event) {
  gaScroll.set();
});



// WEBPACK FOOTER //
// ./src/events.js